<!-- Image Preview Modal -->
<div class="modal-header">
	<h4 class="modal-title">
		{{ imageData?.title || 'Kuvan esikatselu' }}
	</h4>
	<button
		type="button"
		class="btn-close"
		aria-label="Close"
		(click)="dismiss()"
	></button>
</div>

<div class="modal-body text-center">
	<img
		*ngIf="imageData"
		class="img-fluid"
		style="max-height: 70vh; max-width: 100%; object-fit: contain"
		[src]="imageData.imageUrl"
		[alt]="imageData.altText || imageData.title || 'Kuva'"
	/>
</div>

<div class="modal-footer">
	<p class="me-auto text-muted">
		{{ imageData?.subtitle || '' }}
	</p>
	<button type="button" class="btn btn-secondary" (click)="close()">
		Sulje
	</button>
</div>